<template>
    <el-row class="container">
        <el-col :span="24" class="header">
            <keep-alive>
                <mheader></mheader>
            </keep-alive>
        </el-col>
        <el-col :span="24" class="main">
            <transition>
                <keep-alive>
                    <sliderbar></sliderbar>
                </keep-alive>
            </transition>

            <section class="content-container">
                <div class="grid-content bg-purple-light" style="height:100%;">
                    <!--                    <el-col :span="24" class="breadcrumb-container">-->
                    <!--                        <strong class="title">{{$route.meta}}</strong>-->
                    <!--                        <el-breadcrumb separator="/" class="breadcrumb-inner">-->
                    <!--                            <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">-->
                    <!--                                {{ item.meta }}-->
                    <!--                            </el-breadcrumb-item>-->
                    <!--                        </el-breadcrumb>-->
                    <!--                    </el-col>-->
                    <el-col :span="24" class="content-wrapper"
                            style="height:calc(100% - 30px); margin-top:15px;padding:15px;">
                        <transition name="fade" mode="out-in">
                            <router-view></router-view>
                        </transition>
                    </el-col>
                </div>
            </section>
        </el-col>
    </el-row>
</template>

<script>
    import Sliderbar from "./Components/Sliderbar";
    import Mheader from "./Components/VHeader";

    export default {
        components: {Sliderbar, Mheader},
        data() {
            return {
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                }
            }
        },
        methods: {
            onSubmit() {
                console.log('submit!');
            },
            handleopen() {
                //console.log('handleopen');
            },
            handleclose() {
                //console.log('handleclose');
            },
            handleselect: function (a, b) {
            },
            showMenu(i, status) {
                this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
            }
        },
        mounted() {

        }
    }

</script>

<style scoped lang="scss">
    @import '../../styles/vars.scss';

    .container {
        position: absolute;
        top: 0px;
        bottom: 0px;
        width: 100%;

        .header {
            height: 60px;
            line-height: 60px;
            background: $color-primary;
            color: #fff;

            .userinfo {
                text-align: right;
                padding-right: 35px;
                float: right;

                .userinfo-inner {
                    cursor: pointer;
                    color: #fff;

                    img {
                        width: 40px;
                        height: 40px;
                        border-radius: 20px;
                        margin: 10px 0px 10px 10px;
                        float: right;
                    }
                }
            }

            .logo {
                //width:230px;
                height: 60px;
                font-size: 22px;
                padding-left: 20px;
                padding-right: 20px;
                border-color: rgba(238, 241, 146, 0.3);
                border-right-width: 1px;
                border-right-style: solid;

                img {
                    width: 40px;
                    float: left;
                    margin: 10px 10px 10px 18px;
                }

                .txt {
                    color: #fff;
                }
            }

            .logo-width {
                width: 230px;
            }

            .logo-collapse-width {
                width: 60px
            }

            .tools {
                padding: 0px 23px;
                width: 14px;
                height: 60px;
                line-height: 60px;
                cursor: pointer;
            }
        }

        .main {
            display: flex;
            // background: #324057;
            position: absolute;
            top: 60px;
            bottom: 0px;
            overflow: hidden;

            aside {
                flex: 0 0 230px;
                width: 230px;
                // position: absolute;
                // top: 0px;
                // bottom: 0px;
                .el-menu {
                    height: 100%;
                }

                .collapsed {
                    width: 60px;

                    .item {
                        position: relative;
                    }

                    .submenu {
                        position: absolute;
                        top: 0px;
                        left: 60px;
                        z-index: 99999;
                        height: auto;
                        display: none;
                    }

                }
            }

            .menu-collapsed {
                flex: 0 0 60px;
                width: 60px;
            }

            .menu-expanded {
                flex: 0 0 230px;
                width: 230px;
            }

            .content-container {
                height: 100%;
                width: 100%;
                // background: #f1f2f7;
                flex: 1;
                // position: absolute;
                // right: 0px;
                // top: 0px;
                // bottom: 0px;
                // left: 230px;
                overflow-y: auto;
                padding: 0px 0px 0px 10px;

                .breadcrumb-container {
                    //margin-bottom: 15px;
                    .title {
                        width: 200px;
                        float: left;
                        color: #475669;
                    }

                    .breadcrumb-inner {
                        float: right;
                    }
                }

                .content-wrapper {
                    background-color: #fff;
                    box-sizing: border-box;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Backend.vue?3aa05d23